import {
    getGrossVolumeValue,
    getNewCustomers,
    getSuccessfulPayments,
    getCustomersChart,
    getPlanCharts,
    getReportsChart,
    getInterestReport,
    getInterestsTotalPrice,
    getFunnelFilters,
    getPlanFilters,
    getCampaignFilters,
    getSourceFilters,
    getFootprintFilters,
} from '../../api/analytic'

import {
    formatPlanData
} from '../../servises/analyticsFormatData'

const state = {
    grossVolume: [],
    newCustomers: [],
    successfulPayments: [],
    customersChart: {},
    planChart: {},
    reportsChart: {},
    interests: [],
    interestsMeta: {},
    interestsTotalPrice: 0,
    funnelFilters: [],
    planFilters: [],
    campaignFilters:[],
    sourceFilters:[],
    contentFilters:[],
    mediumFilters:[],
    termFilters:[],
    referralFilters:[],
};

const getters = {
    getGrossVolume: state => state.grossVolume,
    getNewCustomers: state => state.newCustomers,
    getSuccessfulPayments: state => state.successfulPayments,
    getCustomers: state => state.customersChart,
    getPlan: state => state.planChart,
    getReports: state => state.reportsChart,
    getInterests: state => state.interests,
    getInterestsMeta: state => state.interestsMeta,
    getInterestsTotalPrice: state => state.interestsTotalPrice,
    getFunnelFilters: state =>state.funnelFilters,
    getPlanFilters: state =>state.planFilters,
    getCampaignFilters: state =>state.campaignFilters,
    getSourceFilters: state =>state.sourceFilters,
    getContentFilters: state =>state.contentFilters,
    getMediumFilters: state =>state.mediumFilters,
    getTermFilters: state =>state.termFilters,
    getReferralFilters: state =>state.referralFilters,
};

const mutations = {
    SET_GROSS_VOLUME: (state, payload) => {
        state.grossVolume = payload
    },
    SET_NEW_CUSTOMERS: (state, payload) => {
        state.newCustomers = payload
    },
    SET_SUCCESS_PAYMENTS: (state, payload) => {
        state.successfulPayments = payload
    },
    SET_CUSTOMERS_CHART: (state, payload) => {
        state.customersChart = payload
    },
    SET_PLAN_CHART: (state, payload) => {
        state.planChart = payload
    },
    SET_REPORTS_CHART: (state, payload) => {
        state.reportsChart = payload
    },
    SET_INTERESTS: (state, payload) => {
        state.interests = payload.data
        state.interestsMeta = payload.meta
    },
    SET_INTERESTS_TOTAL_PRICE: (state, payload) => {
        state.interestsTotalPrice = payload
    },
    SET_FUNNEL_FILTERS: (state, payload) => {
        state.funnelFilters = payload
    },
    SET_PLAN_FILTERS: (state, payload) => {
        state.planFilters = payload
    },
    SET_CAMPAIGN_FILTERS: (state, payload) => {
        state.campaignFilters = payload
    },
    SET_SOURCE_FILTERS: (state, payload) => {
        state.sourceFilters = payload
    },
    SET_MEDIUM_FILTERS: (state, payload) => {
        state.mediumFilters = payload
    },
    SET_TERM_FILTERS: (state, payload) => {
        state.termFilters = payload
    },
    SET_REFERRAL_FILTERS: (state, payload) => {
        state.referralFilters = payload
    },
    SET_CONTENT_FILTERS: (state, payload) => {
        state.contentFilters = payload
    }
};

const actions = {
    getGrossVolume: ({ commit }) => {
        getGrossVolumeValue()
            .then(response => commit('SET_GROSS_VOLUME', response.values))
            .catch(error => error.response)
    },

    getNewCustomers: ({ commit }, date) => {
        getNewCustomers(date)
            .then(response => commit('SET_NEW_CUSTOMERS', response.values))
            .catch(error => error.response)
    },

    getSuccessPayments: ({ commit }, date) => {
        getSuccessfulPayments(date)
            .then(response => commit('SET_SUCCESS_PAYMENTS', response.values))
            .catch(error => error.response)
    },

    getCustomersChart: ({ commit }, date) => {
        getCustomersChart(date)
            .then(response => commit('SET_CUSTOMERS_CHART', response))
            .catch(error => error.message)
    },

    getPlanChart: ({ commit }, date) => {
        getPlanCharts(date)
            .then(response => commit('SET_PLAN_CHART', formatPlanData(response)))
            .catch(error => error.message)
    },

    getReportsChart: ({ commit }, date) => {
        getReportsChart(date)
            .then(response => commit('SET_REPORTS_CHART', formatPlanData(response)))
            .catch(error => error.message)
    },

    getInterestReport: ({ commit }, date) => {
        getInterestReport(date)
            .then(response => commit('SET_INTERESTS', response))
            .catch(error => error.message)
    },

    getInterestsTotalPrice: ({ commit }, date) => {
        getInterestsTotalPrice(date)
            .then(response => commit('SET_INTERESTS_TOTAL_PRICE', response))
            .catch(error => error.message)
    },

    getFunnelFilters: ({ commit }) => {
        getFunnelFilters()
            .then(response => commit('SET_FUNNEL_FILTERS', response))
            .catch(error => error.message)
    },

    getPlanFilters: ({ commit }) => {
        getPlanFilters()
            .then(response => {
                const resultArr = []
                Object.entries(response).forEach((item) => {
                    resultArr.push({ text: item[1], value: Number(item[0]) })})
                commit('SET_PLAN_FILTERS', resultArr)})
            .catch(error => error.message)
    },

    getCampaignFilters: ({ commit }) => {
        getCampaignFilters()
            .then(response => {
                commit('SET_CAMPAIGN_FILTERS', response)})
            .catch(error => error.message)
    },
    getSourceFilters: ({ commit }) => {
        getSourceFilters()
            .then(response => {
                commit('SET_SOURCE_FILTERS', response)})
            .catch(error => error.message)
    },
    getContentFilters: ({ commit }) => {
        getContentFilters()
            .then(response => {
                commit('SET_CONTENT_FILTERS', response)})
            .catch(error => error.message)
    },
    getFootprintFilters: ({ commit },filter_key) => {
        getFootprintFilters()
            .then(response => {
                Object.entries(response).forEach((entity) => {
                    let resultArr = [];
                    Object.entries(entity[1]).forEach((item) => {
                        //let name = s=>s.replace(/./, c=>c.toUpperCase())
                        resultArr.push({ text: item[0].length==0?'Empty':item[1], value: item[0] })
                    })
                    commit(`SET_${(entity[0].toUpperCase())}_FILTERS`, resultArr)
                })
                console.log(resultArr)
                //commit('SET_CONTENT_FILTERS', response)
            })
            .catch(error => error.message)
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
